import { IPromise } from 'angular';
import { LooseAutocomplete } from './utils';

interface UIBModalControllerServiceOptions {
  controller: string | any[];
  templateUrl: string;
  controllerAs?: string;
  bindToController?: boolean;
  keyboard?: boolean;
  size?: LooseAutocomplete<'md' | 'lg' | 'full'>;
  backdrop?: boolean | 'static';
  resolve?: Record<string, unknown>;
}

interface UIBModalComponentServiceOptions {
  component: string;
  size?: LooseAutocomplete<'md' | 'lg' | 'full'>;
  backdrop?: boolean | 'static';
  resolve?: Record<string, unknown>;
}

export type UIBModalServiceOptions = UIBModalControllerServiceOptions | UIBModalComponentServiceOptions;

export type UIBModal<T> = { result: IPromise<T>; close: (result: any) => void; dismiss: (reason?: string) => void };
export type UIBModalService = { open: <T>(options: UIBModalServiceOptions) => UIBModal<T> };

export function createUIBModalStub<T = any>(result: T): UIBModal<T> {
  return {
    close: (result: any) => {},
    dismiss: (reason?: string) => {},
    result: Promise.resolve(result),
  };
}
